
import { useFadeIn } from '../../../hooks/useFadeIn';

export default function OurPosition() {
  const heading = useFadeIn({ direction: 'up' });
  const text = useFadeIn({ direction: 'up', delay: 200 });
  const mobileImg = useFadeIn({ direction: 'left' });
  const pcImg = useFadeIn({ direction: 'left' });

  return (
    <section className="py-20 md:py-20 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto space-y-16">
        <div ref={heading.ref} style={heading.style}>
          <h2 className="text-lg md:text-2xl lg:text-3xl font-normal text-gray-900 tracking-wide text-center font-serif" style={{ lineHeight: '2.5' }}>
            さいわいデンタルクリニックは、<br />
            矯正治療で後悔しないために、<br />
            最初に相談する価値のある医院です。
          </h2>
          <p className="text-sm md:text-base text-gray-500 font-light text-center mt-4 tracking-wide">
            治療を始めることよりも、自分に合った選択を知ることを大切にしています。
          </p>
        </div>
        
        <div className="grid md:grid-cols-[55%_45%] gap-12 items-center">
          {/* スマホ用画像（上に表示） */}
          <div
            ref={mobileImg.ref}
            className="md:hidden w-full"
            style={mobileImg.style}
          >
            <img
              src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/5c11dc833e486f96a29ed1aeb4cb854f.png"
              alt="ガラスと金属の直線的な建築（都市のランドマーク）"
              className="w-full h-auto object-contain"
              style={{ maxHeight: '400px' }}
            />
          </div>

          {/* 左カラム：テキスト */}
          <div ref={text.ref} style={text.style} className="space-y-8 text-gray-700 text-base md:text-lg font-light leading-loose text-left max-w-[600px]">
            <p>
              治療を急かすことは、私たちの誠実さに反します。
            </p>
            <p>
              まずは今の状態を知っていただく。
            </p>
            <p>
              その支援をすることが、私たちの役割です。
            </p>
          </div>

          {/* 右カラム：画像（PC用） */}
          <div
            ref={pcImg.ref}
            className="hidden md:block w-full"
            style={pcImg.style}
          >
            <img
              src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/5c11dc833e486f96a29ed1aeb4cb854f.png"
              alt="ガラスと金属の直線的な建築（都市のランドマーク）"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
